import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=cfc5e24c&scoped=true&"
import script from "./PricingSection.vue?vue&type=script&lang=js&"
export * from "./PricingSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=cfc5e24c&prod&lang=scss&"
import style1 from "./PricingSection.vue?vue&type=style&index=1&id=cfc5e24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc5e24c",
  null
  
)

export default component.exports